import PropTypes from 'prop-types';

const LayoutPinnedLeftIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M46.5 6A1.5 1.5 0 0 1 48 7.5v33a1.5 1.5 0 0 1-1.5 1.5h-45A1.5 1.5 0 0 1 0 40.5v-33A1.5 1.5 0 0 1 1.5 6h45zm-3 25.5h-9v6h8.25a.75.75 0 0 0 .75-.75V31.5zM30 10.5H5.25a.75.75 0 0 0-.75.75v25.5c0 .414.336.75.75.75H30v-27zM43.5 21h-9v6h9v-6zm-.75-10.5H34.5v6h9v-5.25a.75.75 0 0 0-.75-.75z"
          id="qlfqbeqf1a"
        />
      </defs>
      <use fill={fill} xlinkHref="#qlfqbeqf1a" fillRule="evenodd" />
    </svg>
  </div>
);

LayoutPinnedLeftIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

LayoutPinnedLeftIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default LayoutPinnedLeftIcon;
